import axios from "axios";
import { URL_BACKEND_APP } from "../App.constants";

const annee_scolaire_api = axios.create({
  baseURL: URL_BACKEND_APP + "/annee_scolaire",
});
const classe_api = axios.create({
  baseURL: URL_BACKEND_APP + "/classe",
});
const domaine_etude_api = axios.create({
  baseURL: URL_BACKEND_APP + "/domaine",
});
const fonction_api = axios.create({
  baseURL: URL_BACKEND_APP + "/fonction",
});
const grade_api = axios.create({
  baseURL: URL_BACKEND_APP + "/grade",
});
const terminal_api = axios.create({
  baseURL: URL_BACKEND_APP + "/terminal",
});
const montant_api = axios.create({
  baseURL: URL_BACKEND_APP + "/montant",
});

const ANNEE_SCOLAIRE = {
  create: (data, token) => {
    return annee_scolaire_api.post("/create.php", data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  },
  getOne: (id, token) => {
    return annee_scolaire_api.get(`/readById.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getAll: (token) => {
    return annee_scolaire_api.get("/read.php", {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  update: (id, data, token) => {
    return annee_scolaire_api.put("/update.php?id=" + id, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  delete: (id, token) => {
    return annee_scolaire_api.delete(`/delete.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

const CLASSE = {
  create: (data, token) => {
    return classe_api.post("/create.php", data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  },
  getOne: (id, token) => {
    return classe_api.get(`/readById.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getAll: (token) => {
    return classe_api.get("/read.php", {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  update: (id, data, token) => {
    return classe_api.put("/update.php?id=" + id, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  active: (id, token) => {
    return classe_api.get("/active.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  desactive: (id, token) => {
    return classe_api.get("/desactive.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  delete: (id, token) => {
    return classe_api.delete(`/delete.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

const DOMAINE_ETUDE = {
  create: (data, token) => {
    return domaine_etude_api.post("/create.php", data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  },
  getOne: (id, token) => {
    return domaine_etude_api.get(`/readById.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getAll: (token) => {
    return domaine_etude_api.get("/read.php", {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  update: (id, data, token) => {
    return domaine_etude_api.put("/update.php?id=" + id, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  active: (id, token) => {
    return domaine_etude_api.get("/active.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  desactive: (id, token) => {
    return domaine_etude_api.get("/desactive.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  delete: (id, token) => {
    return domaine_etude_api.delete(`/delete.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
const FONCTION = {
  create: (data, token) => {
    return fonction_api.post("/create.php", data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  },
  getOne: (id, token) => {
    return fonction_api.get(`/readById.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getAll: (token) => {
    return fonction_api.get("/read.php", {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  update: (id, data, token) => {
    return fonction_api.put("/update.php?id=" + id, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  active: (id, token) => {
    return fonction_api.get("/active.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  desactive: (id, token) => {
    return fonction_api.get("/desactive.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  delete: (id, token) => {
    return fonction_api.delete(`/delete.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
const GRADE = {
  create: (data, token) => {
    return grade_api.post("/create.php", data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  },
  getOne: (id, token) => {
    return grade_api.get(`/readById.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getAll: (token) => {
    return grade_api.get("/read.php", {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  update: (id, data, token) => {
    return grade_api.put("/update.php?id=" + id, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  active: (id, token) => {
    return grade_api.get("/active.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  desactive: (id, token) => {
    return grade_api.get("/desactive.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  delete: (id, token) => {
    return grade_api.delete(`/delete.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
const TERMINAL = {
  create: (data, token) => {
    return terminal_api.post("/create.php", data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  },
  getOne: (id, token) => {
    return terminal_api.get(`/readById.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getAll: (token) => {
    return terminal_api.get("/read.php", {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  update: (id, data, token) => {
    return terminal_api.put("/update.php?id=" + id, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  active: (id, token) => {
    return terminal_api.get("/active.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  desactive: (id, token) => {
    return terminal_api.get("/desactive.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  delete: (id, token) => {
    return terminal_api.delete(`/delete.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
const MONTANT_ANNUEL = {
  create: (data, token) => {
    return montant_api.post("/create.php", data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  },
  getOne: (id, token) => {
    return montant_api.get(`/readById.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  getAll: (token) => {
    return montant_api.get("/read.php", {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  update: (id, data, token) => {
    return montant_api.put("/update.php?id=" + id, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  active: (id, token) => {
    return montant_api.get("/active.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
  desactive: (id, token) => {
    return montant_api.get("/desactive.php?id=" + id, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  delete: (id, token) => {
    return montant_api.delete(`/delete.php?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

export const API_CONFIG = {
  ANNEE_SCOLAIRE,
  CLASSE,
  DOMAINE_ETUDE,
  FONCTION,
  GRADE,
  TERMINAL,
  MONTANT_ANNUEL,
};
